import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Result } from '@digibricks/core';
import { AnswerType, EssayAnswer, FillInBlankGroupAnswer, GET_ANSWERS_USE_CASE, MultipleChoiceAnswer, SingleChoiceAnswer, GET_RECORDED_ELAPSED_TIME_USE_CASE, MatchingAnswerGroup } from '../../../core';
export var SUBMISSION_WEB_CACHED = 'SUBMISSION_WEB_CACHED';
export var SubmissionWebCached = /*#__PURE__*/function () {
  function SubmissionWebCached() {
    _classCallCheck(this, SubmissionWebCached);
  }

  _createClass(SubmissionWebCached, [{
    key: "getCachedAnsweredQuestionIds",
    value: function getCachedAnsweredQuestionIds() {
      if (!localStorage.getItem('answered_question_ids')) {
        return [];
      }

      return localStorage.getItem('answered_question_ids').split(',');
    }
  }, {
    key: "getSubmissionAnswerCached",
    value: function getSubmissionAnswerCached(submissionId, sectionId) {
      var hasEmptySubmissionAnswer = true;
      var cachedData = localStorage.getItem(GET_ANSWERS_USE_CASE);
      if (!cachedData) return [];
      var parseCachedData = JSON.parse(cachedData);
      if (!submissionId && !sectionId) return parseCachedData;
      var submissionAnswerCachedData = parseCachedData.find(function (p) {
        return p.submissionId === submissionId && p.sectionId === sectionId;
      });
      if (!submissionAnswerCachedData) return [];
      var resultCombine = [];
      submissionAnswerCachedData.data.forEach(function (answer) {
        var answerProps = _objectSpread({}, answer.props);

        if (answerProps.values) {
          answerProps.values = answerProps.values.map(function (v) {
            return v.props;
          });
        }

        if (answerProps.value) {
          answerProps.value = answerProps.value.props;
        }

        switch (answerProps.type) {
          case AnswerType.Essay:
            {
              resultCombine.push(EssayAnswer.fromJson(answerProps));
              break;
            }

          case AnswerType.SingleChoice:
            {
              resultCombine.push(SingleChoiceAnswer.fromJson(answerProps));
              break;
            }

          case AnswerType.MultipleChoice:
            {
              resultCombine.push(MultipleChoiceAnswer.fromJson(answerProps));
              break;
            }

          case AnswerType.Matching:
            {
              resultCombine.push(MatchingAnswerGroup.fromJson(answerProps));
              break;
            }

          default:
            {
              resultCombine.push(FillInBlankGroupAnswer.fromJson(answerProps));
              break;
            }
        }
      });

      if (Result.combineArray(resultCombine).getValue().length === 0) {
        return {
          hasEmptySubmissionAnswer: hasEmptySubmissionAnswer
        };
      }

      return Result.combineArray(resultCombine).getValue();
    }
  }, {
    key: "createSubmissionAnswerCached",
    value: function createSubmissionAnswerCached(submissionId, sectionId, answerValue) {
      var cachedData = this.getSubmissionAnswerCached();
      cachedData.forEach(function (item) {
        if (item.submissionId === submissionId && item.sectionId === sectionId) {
          item.data = [].concat(_toConsumableArray(item.data), [answerValue]);
        }
      });
      localStorage.setItem(GET_ANSWERS_USE_CASE, JSON.stringify(cachedData));
    }
  }, {
    key: "updateSubmissionFillInBlankAnswerCached",
    value: function updateSubmissionFillInBlankAnswerCached(submissionId, answerBlankId, answerValue) {
      var cachedData = this.getSubmissionAnswerCached();
      cachedData.forEach(function (item) {
        if (item.submissionId === submissionId) {
          item.data.forEach(function (v) {
            if (v.props.answers) {
              v.props.answers.forEach(function (answer) {
                if (answer.props.id === answerBlankId) {
                  answer.props.value = answerValue;
                }
              });
            }
          });
        }
      });
      localStorage.setItem(GET_ANSWERS_USE_CASE, JSON.stringify(cachedData));
    }
  }, {
    key: "updateSubmissionMatchingAnswerCached",
    value: function updateSubmissionMatchingAnswerCached(submissionId, subQuestionId, answerValue) {
      var cachedData = this.getSubmissionAnswerCached();
      cachedData.forEach(function (item) {
        if (item.submissionId === submissionId) {
          item.data.forEach(function (v) {
            if (v.props.answers) {
              v.props.answers.forEach(function (answer) {
                if (answer.props.subQuestionId === subQuestionId) {
                  answer.props.value = answerValue;
                }
              });
            }
          });
        }
      });
      localStorage.setItem(GET_ANSWERS_USE_CASE, JSON.stringify(cachedData));
    }
  }, {
    key: "updateSubmissionMultipleChoiceAnswerCached",
    value: function updateSubmissionMultipleChoiceAnswerCached(submissionId, answerId, answerValues) {
      var cachedData = this.getSubmissionAnswerCached();
      cachedData.forEach(function (item) {
        if (item.submissionId === submissionId) {
          item.data.forEach(function (v) {
            if (v.props.id === answerId) {
              var formatAnswerValues = answerValues.map(function (a) {
                return {
                  props: a
                };
              });
              v.props.values = formatAnswerValues;
            }
          });
        }
      });
      localStorage.setItem(GET_ANSWERS_USE_CASE, JSON.stringify(cachedData));
    }
  }, {
    key: "updateSubmissionSingleChoiceAnswerCached",
    value: function updateSubmissionSingleChoiceAnswerCached(submissionId, answerId, answerValue) {
      var cachedData = this.getSubmissionAnswerCached();
      cachedData.forEach(function (item) {
        if (item.submissionId === submissionId) {
          item.data.forEach(function (v) {
            if (v.props.id === answerId) {
              v.props.value.props.answerId = answerValue;
            }
          });
        }
      });
      localStorage.setItem(GET_ANSWERS_USE_CASE, JSON.stringify(cachedData));
    }
  }, {
    key: "updateSubmissionEssayAnswerCached",
    value: function updateSubmissionEssayAnswerCached(submissionId, answerId, answerValue) {
      var cachedData = this.getSubmissionAnswerCached();
      cachedData.forEach(function (item) {
        if (item.submissionId === submissionId) {
          item.data.forEach(function (v) {
            if (v.props.id === answerId) {
              v.props.value.props.text = answerValue;
            }
          });
        }
      });
      localStorage.setItem(GET_ANSWERS_USE_CASE, JSON.stringify(cachedData));
    }
  }, {
    key: "updateAnsweredQuestionCached",
    value: function updateAnsweredQuestionCached(questionId, sectionId) {
      var cachedAnsweredQuestion = localStorage.getItem('answered_question_ids');

      if (!cachedAnsweredQuestion || cachedAnsweredQuestion && cachedAnsweredQuestion.includes("".concat(questionId, "_").concat(sectionId))) {
        localStorage.setItem('answered_question_ids', "".concat(questionId, "_").concat(sectionId));
        return;
      }

      localStorage.setItem('answered_question_ids', cachedAnsweredQuestion + ",".concat(questionId, "_").concat(sectionId));
    }
  }, {
    key: "setElapsedTimeCached",
    value: function setElapsedTimeCached(props) {
      var submissionId = props.submissionId,
          elapsedTime = props.elapsedTime;
      localStorage.setItem("".concat(GET_RECORDED_ELAPSED_TIME_USE_CASE, "_").concat(submissionId), JSON.stringify(elapsedTime));
    }
  }, {
    key: "getElapsedTimeCached",
    value: function getElapsedTimeCached(props) {
      var submissionId = props.submissionId;
      var cachedData = localStorage.getItem("".concat(GET_RECORDED_ELAPSED_TIME_USE_CASE, "_").concat(submissionId));
      return JSON.parse(cachedData);
    }
  }]);

  return SubmissionWebCached;
}();